import {Component} from 'react';
import { doubleToStringMonthly} from '../../../objects/CommonUse/double_functions';
import { reformatDateToDisplay } from '../../../objects/CommonUse/reformatDateToDisplay_function';
import tranTypeClass from './datasets/tran_type_class';

class SavingsTransactionDisplayCard extends Component {
    constructor(props) {
        super(props);
        this.state = {open: false, 
             selected: false,
           
        };
        this.previousTranMonth = "";
        this.initializeProcess();
    }

    initializeProcess(){
        this.tranTypeClass = tranTypeClass;
        this.determineDisplayClass();
    }
  
    determineDisplayClass(){
        this.amountClass = "text-right ";
        this.dateClass = "text-center";
        this.rowClass = "";
        if (this.props.tranInfo.tranAmt < 0){
            this.amountClass += " text-danger";
        }
        this.textClass = "text-left";
        if (this.props.displayType === "detail"){
          
            if (this.props.tranInfo.tranDate && this.props.tranInfo.tranDate.includes("-")){
                this.tranDate = reformatDateToDisplay(this.props.tranInfo.tranDate);
            }else{
                this.tranDate = "9999999";
            }
        }else{
            this.tranDate = this.props.tranInfo.tranYear;
        }
        const textClassObj = this.tranTypeClass.find(elem => elem.tranType === this.props.tranInfo.tranType);
        if (textClassObj){
            this.textClass = textClassObj.class;
            this.dateClass += " " + textClassObj.class;
            this.amountClass += " " + textClassObj.class;
        }
    }
    
    render() {
        this.determineDisplayClass();
        if (this.props.displayType === "detail" && this.props.savingsClass === "retirement"){  
            if (this.props.tranInfo.sharePrice === ""){
                this.sharePrice = "";
            }else{
                this.sharePrice = doubleToStringMonthly(this.props.tranInfo.sharePrice);
            }
        }
    return <>
        <tr className={this.rowClass}>
            <td className={this.textClass}>{this.props.tranInfo.tranType}</td> 
            <td className={this.dateClass}>{this.tranDate}</td>
            {this.props.savingsClass === "retirement" ?
                <>
                    {this.props.tranInfo.tranType === "Federal Income Tax - Transfer" ?
                        <td colSpan="2"></td>
                    :
                    <>
                        <td className={this.amountClass}>
                            {this.props.tranInfo.shareQuantity}
                        </td>
                        {this.props.displayType === "detail" ?
                            <td className={this.amountClass}>
                               {this.sharePrice}
                            </td>
                        :
                            null
                        }
                    </>
                    }
                </>
            :
                null
            }

            <td className={this.amountClass}>{doubleToStringMonthly(this.props.tranInfo.tranAmt)}</td>
        </tr>
        {this.props.tranInfo.tranType === "Monthly Total" ?
            <tr>
                <td colSpan="3" style={{ height: "10px" }}></td>
            </tr>
         :
            null
         }
          
    </>
    }

}

export default SavingsTransactionDisplayCard;